'use client';

import { useStyleSchema } from '@components/styleSchema/StyleSchemaHandler';
import Image from 'next/image';
import { AnimatePresence, motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '@store/selectors/auth.selectors';

export const Disturber = () => {
  const { currentSchema } = useStyleSchema();
  const isAuthenticated = useSelector(selectIsAuthenticated);
    
    if (isAuthenticated) {
        return null;
    }

  // Wenn kein Disturber im Schema vorhanden ist, zeige nichts an
  if (!currentSchema.disturber) {
    return null;
  }

  const { title, imagePath, altText } = currentSchema.disturber;

  return (
    <AnimatePresence>
      <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          className="relative w-full bg-primary-50 overflow-hidden"
        >
          <div className="container mx-auto px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-4">
              {imagePath && (
                <div className="relative w-80 h-80 rounded-full overflow-hidden">
                  <Image
                    src={imagePath}
                    alt={altText || title}
                    fill
                    style={{ objectFit: 'cover' }}
                  />
                </div>
              )}
            </div>
          </div>
        </motion.div>
    </AnimatePresence>
  );
};
